// extracted by mini-css-extract-plugin
export default {"product":"KX","image_carousel":"LX","main_gallery":"MX","personalized_badge":"NX","greens_badge":"OX","arrows":"PX","slide":"QX","thumbnail_gallery":"RX","swiper-slide":"SX","learn_more":"TX","product_info":"UX","description_wrapper":"VX","checklist":"WX","checklistItem":"XX","delivery_freq":"YX","tooltip_button":"ZX","key_benefits":"aY","benefit_item":"bY","ingredients":"cY","ingredient_item":"eY","active_slide":"fY","benefits_list":"gY","checkmark":"hY"};
    if(module.hot) {
      // 1711394579957
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  